import QueryString from "qs";
import Page410 from "@/Components/410/410";
import CaseStudyPage from "@/Components/pages/case-study";
import { GetServerSideProps, NextPage } from "next";

const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_API_BASE_URL;

export const getServerSideProps: GetServerSideProps = async (ctx) => {
  const slug = "case-studies";
  if (process.env.NEXT_PUBLIC_CACHE_PAGES) {
    ctx.res.setHeader(
      "Cache-Control",
      "public, s-maxage=18000, stale-while-revalidate=59"
    );
  }

  let apiRes = null;
  let apiResData = null;
  let isNew = false;
  const query = QueryString.stringify(
    {
      publicationState: "preview",
      filters: {
        slug: {
          $eq: slug,
        },
      },
      populate: "deep, 10",
    },
    {
      encodeValuesOnly: false,
    }
  );
  apiRes = await fetch(
    `${baseUrl}case-studies-v2?${decodeURIComponent(query)}`
  );
  apiResData = await apiRes.json();
  isNew = apiResData?.data[0]?.attributes?.design === "new";
  return {
    props: {
      apiResData,
      slug,
      status: 200,
      isNew,
    },
  };
};

interface Props {
  apiResData: any;
  slug: string;
  status: number;
  isNew: boolean;
}

const CaseStudies: NextPage<Props> = ({ apiResData, slug, status }) => {
  return (
    <div id="root">
      {status == 410 ? (
        <Page410 />
      ) : (
        <div>
          <CaseStudyPage slug={slug} data={apiResData} />
        </div>
      )}
    </div>
  );
};

export default CaseStudies;
